export default class HttpService {
    /* @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    get(url, config) {
        return this.$http.get(url, config);
    }

    delete(url, config) {
        return this.$http.delete(url, config);
    }

    post(url, data, config) {
        return this.$http.post(url, data, config);
    }

    put(url, data, config) {
        return this.$http.put(url, data, config);
    }

    patch(url, data, config) {
        return this.$http.patch(url, data, config);
    }
}



// WEBPACK FOOTER //
// ./src/common/service/communication/http.service.js